export const isJson = (str: string): boolean => {
  try {
    JSON.parse(str);
  } catch {
    return false;
  }
  return true;
};

export const isJsonBlob = (value: string): boolean => {
  try {
    const parsed = JSON.parse(value);

    return typeof parsed === "object" && parsed !== null;
  } catch {
    return false;
  }
};
